// Starting a visit (person page "New assessment", event roster "Start"): Physical, COHSG screening or Labs only.
import type { VisitType } from './Intake.tsx';

/** "New assessment": what kind of visit. It decides the form (and the report). Most visits are a physical or a COHSG screening. */
export function NewVisitChooser({ onPick, onCancel }: { onPick: (t: VisitType) => void; onCancel: () => void }) {
  const choice = (t: VisitType, title: string, text: string, primary: boolean) => (
    <button type="button" className={`visit-choice${primary ? '' : ' minor'}`} onClick={() => onPick(t)}>
      <b>{title}</b><span>{text}</span>
    </button>);
  return (
    <div className="visit-chooser">
      <div className="small muted">What kind of visit?</div>
      <div className="visit-choices">
        {choice('physical', 'Physical', 'NGF fitness assessment: body composition, blood pressure, blood work, cycle test, spirometry. Full report packet.', true)}
        {choice('cohsg', 'COHSG screening', 'Health questionnaire, height and weight, blood pressure, blood work, smoking. Report: coronary risk page.', true)}
        {choice('labs', 'Labs only', 'Blood work only. Results are filed from the LabCorp report.', false)}
      </div>
      <button type="button" className="secondary small" onClick={onCancel}>Cancel</button>
    </div>);
}
